var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 154,
    viewBox: "0 0 153 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8428,
    cy: 147.654,
    rx: 74.1573,
    ry: 6.34615,
    fill: "#F2F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.781 79.5386H91.1685V145.539H139.202L138.781 79.5386Z",
    fill: "#D0E7FF",
    stroke: "#6297CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7472 79.1156L4.79214 70.231H47.7697L58.7247 79.1156H90.7472L74.3146 106.616H1L15.7472 79.1156Z",
    fill: "#A1D6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7472 79.1156L4.79214 70.231H47.7697L58.7247 79.1156M15.7472 79.1156H58.7247M15.7472 79.1156L1 106.616H74.3146L90.7472 79.1156H58.7247",
    stroke: "#6297CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5898 145.539L16.1685 107.039H74.7359L90.7471 80.3848V145.539H16.5898Z",
    fill: "white",
    stroke: "#6297CB",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.809 71.0771L90.3257 79.5387H139.202L151 71.0771H103.809Z",
    fill: "#A1D6FF",
    stroke: "#6297CB",
    strokeWidth: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.152,
    y: 93.5771,
    width: 20.9101,
    height: 4.07692,
    rx: 2.03846,
    fill: "#FAFFFF",
    stroke: "#6D99CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2589 8.46143C20.5567 23.4101 30.3601 52.6307 75.1915 49.923C120.023 47.2153 120.276 36.3845 114.799 31.3076C105.529 23.2691 85.0513 15.3999 77.2985 48.2307C76.0345 51.3332 73.5906 60.0768 73.9277 70.2307",
    stroke: "#6297CB",
    strokeWidth: 0.7,
    strokeDasharray: "4 3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4957 2.53846C24.4957 3.88557 23.4083 4.97692 22.0676 4.97692C20.727 4.97692 19.6396 3.88557 19.6396 2.53846C19.6396 1.19135 20.727 0.1 22.0676 0.1C23.4083 0.1 24.4957 1.19135 24.4957 2.53846Z",
    fill: "#CFE7FF",
    stroke: "#6297CB",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.f899a67bb0cb60fe73c2dca99b501de9.svg";
export { ForwardRef as ReactComponent };